import React from "react";
import PageHeader from "../components/shared/pageHeader/PageHeader";
import LeadsCreateHeader from "../components/leads/StockFeatureHeader";
import LeadsCreateContent from "../components/leads/StockReportTable";
import CustomerAnalytics from "../components/leads/CustomerAnalytics";
import SalesAnalytics from "../components/leads/SalesAnalytics";
import Footer from "../components/shared/Footer";

const OrganisationTable = () => {
  return (
    <>
      <PageHeader></PageHeader>

      <div className="main-content">
        <div className="row">
          <LeadsCreateContent />
          <CustomerAnalytics/>
          <SalesAnalytics/>
        </div>
      </div>
    </>
  );
};

export default OrganisationTable;
